(function () {
  'use strict';

  angular
    .module('crewing')
    .controller('EvaluateTrainingsCtrl', EvaluateTrainingsCtrl);

  function EvaluateTrainingsCtrl($uibModalInstance, CrewingHelper, modalParams,MessageService, CommonMasterData) {
    var vm = this;
    vm.model = {
      allSelect: true,
      info: modalParams,
      allResults: [{name: 'PASS'}, {name: 'FAIL'}],
      selectedResult: '',
      signOut: [],
      request: {
        crewProfileId: modalParams.isForDay ? [modalParams.crew.crewDTO.crewProfileId] : [],
        message: modalParams.messageContent,
        no_of_house: 24,
        isConfirm: false
      },

    };

    vm.selectAllCrewForTraining = function (training) {
      if (training.allCrewSelected) {
        angular.forEach(training.assignedCrewTrainingDetails, function (crew) {
          if (training.expiryUpdatable && crew.trainingCategory === 'TRAINEE') {
            crew.isChecked = true;
          }

        });
      }
      else {
        angular.forEach(training.assignedCrewTrainingDetails, function (crew) {
            crew.isChecked = false;
        });
      }
    };

    vm.closeMe = function () {
      $uibModalInstance.close();
    };

    vm.updateResults = function () {
      var requestDtos = [];
      angular.forEach(vm.model.info, function (training) {
        angular.forEach(training.assignedCrewTrainingDetails, function (crew) {
          if (crew.isChecked) {
            requestDtos.push(getUpdateExpiryDetails(training, crew));
          }
        })
      });

      if (requestDtos.length !== 0 && typeof(vm.model.selectedResult.name) !== 'undefined') {
        CrewingHelper.updateExpiryMultipleTrainings(requestDtos,
          function (data) {
            if (data.success) {
              $uibModalInstance.close('SUCCESS');
              MessageService.success("Results have been updated Successfully");
            }
          },
          function (error) {
            MessageService.error(error.msg[0]);
          }
        );
      }
      else if (requestDtos.length === 0) {
        MessageService.warning("No Training/ Crew is selected");
      }
      else {
        MessageService.warning("Please select a result before updating");
      }
    };

    function getUpdateExpiryDetails(training, crew) {
      var updateExpiry = {
        module: crew.moduleId,
        remarks: crew.remarks,
        expiryUpdatable: training.expiryUpdatable ? "Y": "N",
        crewSchdTrainingSlotId: crew.crewScheduleTrainingSlotId,
        crewSchdTrainingSlotVersion: crew.crewSchdTrainingSlotVersion,
        result: vm.model.selectedResult.name,
        validationNo: crew.validationNo,
        valTransactionId: crew.validationId,
        valTransactionVersion: crew.version,
        crewExpiryDeletePrivi: true,
        ignoreExpiryExists: true,
        crewProfileId: crew.crewProfileId,
        crewId: crew.crewId,
        trainingSlotId: training.trainingSlotId,
        ignoreExpiryProcess: true,
        programId: training.trainingProgramId,
        ignoreObjectExpiryExists: '',
        ignoreObjectExpiryProcess: '',
        trainingStartDate: training.trainingFromDateStr,
        trainingStartTime: training.trainingFromTimeStr
      };
      return updateExpiry;
    }
  }

}());
